import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/useAuth";
import NavbarComp from "../components/NavBar";

type Props = { children: React.ReactNode };

const AdminRoute = ({ children }: Props) => {
    const loc = useLocation();
    const { logedIsAdmin } = useAuth();
    return logedIsAdmin() ? (
        <>{children}</>
    ) : (
        <Navigate to="/" state={{ from: loc }} replace />
    );
};

export default AdminRoute;
